import React, { Component } from "react";
import { NeedLoginContext } from './need-login'

import { getUser } from "@/api/nav";
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideInviteModel: true,
      userName: "",
      verificationType: 0,
      verificationStatus: 0,
      inWhiteList: false
    };
  }

  static contextType = NeedLoginContext;

  getVerificationText() {
    const { inWhiteList, verificationStatus, verificationType } = this.state;
    let verificationText = "未认证";
    if (verificationStatus === 2) {
      switch (verificationType) {
        case 1:
          verificationText = "个人认证";
          break;
        case 2:
          verificationText = "企业认证";
          break;
        case 3:
          verificationText = "白名单";
          break;
        case 4:
          verificationText = "机构认证";
          break;
        default:
          verificationText = "未认证";
      }
    } else if (inWhiteList) {
      verificationText = "白名单";
    }
    return verificationText;
  }

  componentDidMount() {
    getUser().then(res => {
      if (res.ret === 0) {
        this.setState({
          userName: res.data.username,
          verificationType: res.data.verification_type,
          verificationStatus: res.data.verification_status,
          inWhiteList: false,
        });
        
      } else {
        if (this.context && window.location.href.indexOf('kuaizhan') > -1) {
          window.location.href = "/v3/passport/login";
        }
      }
    }).catch(() => {
      if (this.context && window.location.href.indexOf('kuaizhan') > -1) {
        window.location.href = "/v3/passport/login";
      }
    });
  }

  render() {
    let userPanel = [
      { href: "/v5/withdraw", name: "账号钱包" },
      { href: "/passport/logout", name: "退出登录" }
    ];
    return (
      <div className="header-cell header-user">
        <span className="user-text">{this.state.userName}</span>
        <div className="user-panel">
          <div className="user-tranigle" />
          <ul className="user-panel-list">
            <li className="user-panel-item">
              <a href="/user/account-settings">
                <span>账号设置</span>
                <span className="user-panel-verify">
                  {this.getVerificationText()}
                </span>
              </a>
            </li>
            {userPanel.map((item, index) => {
              return (
                <li className="user-panel-item" key={index}>
                  <a href={item.href}>
                    <span>{item.name}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default User;
